export default __webpack_public_path__ + "static/media/gray_modal_close.3988e58a.svg";